import * as XLSX from 'xlsx';

const writeFile = (wb, name) => XLSX.writeFile(wb, `${name}.xlsx`);

export const exportResumen = (detalleOS, mes, anio) => {
  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.json_to_sheet(detalleOS.map(r => ({
    'Obra Social': r.nombre,
    'Cantidad':   r.cantidad,
    'Total':      r.total,
  })));
  XLSX.utils.book_append_sheet(wb, ws, 'Resumen OS');
  writeFile(wb, `Resumen_${mes}_${anio}`);
};

export const exportFacturacionCentro = (items, label, mes, anio) => {
  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.json_to_sheet(items.map(r => ({
    'Fecha':        r.fechaFacturacion ? new Date(r.fechaFacturacion).toLocaleDateString('es-AR') : '',
    'Apellido':     r.apellido,
    'Nombre':       r.nombre,
    'DNI':          r.dni,
    'Nro Afiliado': r.nroAfiliado,
    'Práctica':     r.practica,
    'Código':       r.codigoPractica,
    'Nro Factura':  r.nroFactura,
    'Importe':      r.importe,
    'Obra Social':  r.obraSocial,
  })));
  XLSX.utils.book_append_sheet(wb, ws, label);
  writeFile(wb, `Facturacion_${label}_${mes}_${anio}`);
};

export const exportIngresos = (items, mes, anio) => {
  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.json_to_sheet(items.map(r => ({
    'Obra Social': r.obraSocial,
    'Cantidad':   r.cantidad,
    'Sin Precio': r.sinPrecio,
    'Total':      r.total,
  })));
  XLSX.utils.book_append_sheet(wb, ws, 'Ingresos');
  writeFile(wb, `Ingresos_${mes}_${anio}`);
};

export const exportEgresos = (tecnicos, medicos, mes, anio) => {
  const wb = XLSX.utils.book_new();
  const mapRow = r => ({ 'Nombre': r.nombre, 'Cantidad': r.cantidad, 'Total': r.total });
  XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(tecnicos.map(mapRow)), 'Técnicos');
  XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(medicos.map(mapRow)),  'Médicos');
  writeFile(wb, `Egresos_${mes}_${anio}`);
};
